<template>
    <div>
        <div v-if="basicClaimId != -1">
            <div class="content-caption dashed">
                <div class="left fl">
                    <span><span class="color-laber"></span>价格质量要求详情</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">商品分类</div>
                <div class="content">
                    <label class="mr20">{{servcBasicCalim.goodsCatName || ''}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">服务类型</div>
                <div class="content">
                    <label class="mr20">{{servcTypeMap[servcBasicCalim.servcTypeId] || ''}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">服务分类</div>
                <div class="content">
                    <label class="mr20">{{servcBasicCalim.servcCatName || ''}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">上门费(元)</div>
                <div class="content">
                    <label class="mr20" v-if="servcBasicCalim.toDoorFee != null">{{servcBasicCalim.toDoorFee.toFixed(2)}}</label>
                    <label class="mr20" v-else>0</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">服务费(元)</div>
                <div class="content">
                    <label class="mr20" v-if="servcBasicCalim.generallFee != null">{{servcBasicCalim.generallFee.toFixed(2)}}</label>
                    <label class="mr20" v-else>0</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">响应时长(分)</div>
                <div class="content">
                    <label class="mr20">{{servcBasicCalim.rspTimeMi || 0}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">上门时长(分)</div>
                <div class="content">
                    <label class="mr20">{{servcBasicCalim.arriveTimeMi || 0}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">维修时长(分)</div>
                <div class="content">
                    <label class="mr20">{{servcBasicCalim.repairedTimeMi || 0}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">回询时限(分)</div>
                <div class="content">
                    <label class="mr20">{{servcBasicCalim.telCallTimeMi || 0}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">质保期(天)</div>
                <div class="content">
                    <label class="mr20">{{servcBasicCalim.wrntPeriod || 0}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">备注</div>
                <div class="content">
                    <label class="mr20">{{servcBasicCalim.memo || ''}}</label>
                </div>
            </div>
        </div>

        <div v-if="accClaimId != -1">
            <div class="content-caption dashed">
                <div class="left fl">
                    <span><span class="color-laber"></span>配件要求详情</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">商品分类</div>
                <div class="content">
                    <label class="mr20">{{servcAccCalim.goodsCatName || ''}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">服务类型</div>
                <div class="content">
                    <label class="mr20">{{servcTypeMap[servcAccCalim.servcTypeId] || ''}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">服务分类</div>
                <div class="content">
                    <label class="mr20">{{servcAccCalim.servcCatName || ''}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">配件名称</div>
                <div class="content">
                    <label class="mr20">{{servcAccCalim.name || ''}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">规格要求</div>
                <div class="content">
                    <label class="mr20">{{servcAccCalim.spec || ''}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">价格下限(元)</div>
                <div class="content">
                    <label class="mr20" v-if="servcAccCalim.price != null && servcAccCalim.price != 0">{{servcAccCalim.price.toFixed(2)}}</label>
                    <label class="mr20" v-else>无要求</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">价格上限(元)</div>
                <div class="content">
                    <label class="mr20" v-if="servcAccCalim.price2 != null && servcAccCalim.price2 != 0">{{servcAccCalim.price2.toFixed(2)}}</label>
                    <label class="mr20" v-else>无要求</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">备注</div>
                <div class="content">
                    <label class="mr20">{{servcAccCalim.memo || ''}}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcClaimApi from '../../api/servcClaim'

    export default {
        name: 'swb-acc-and-basic-claim-info',
        desc: '配件/价格质量要求详情',
        props: ["accClaimId", 'basicClaimId'],
        data: function () {
            return {
                servcTypeMap: {},
                //
                servcBasicCalim: {},
                servcAccCalim: {},
            }
        },
        created: function () {
            this.servcTypeMap = getEnumMap('servcType', 'value2text');
            //
            if(!Utils.isNoB(this.basicClaimId)) {
                this.getServcBasicClaimInfo(this.basicClaimId);
            }
            if(!Utils.isNoB(this.accClaimId)) {
                this.getServcAccCalimInfo(this.accClaimId);
            }
        },
        methods: {
            getServcBasicClaimInfo: function (basicClaimId) {
                let self = this;
                let postData = {
                    id: basicClaimId
                };
                let theLoading = MsgBox.loading();
                servcClaimApi.getServcBasicClaimById(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.servcBasicCalim = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getServcAccCalimInfo: function (accClaimId) {
                let self = this;
                let postData = {
                    id: accClaimId
                };
                let theLoading = MsgBox.loading();
                servcClaimApi.getServcAccClaimInfo(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.servcAccCalim = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/servcClaim/AccAndBasicClaimInfo.vue